import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { CHAPTERS } from "../../data";
import { Reveal } from "./primitives";

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["4%", "-22%"]);

  return (
    <section
      ref={ref}
      id="why"
      data-testid="manifesto"
      className="relative py-24 md:py-36 px-6 md:px-12 lg:px-16 bg-brand-asphalt border-y border-brand-concrete overflow-hidden"
    >
      <motion.span
        style={{ x }}
        aria-hidden="true"
        className="absolute top-6 left-0 font-anton uppercase text-[20vw] leading-none text-stroke opacity-30 whitespace-nowrap pointer-events-none select-none"
      >
        Built Different
      </motion.span>

      <div className="relative">
        <Reveal>
          <span className="font-mono-p text-xs uppercase tracking-[0.28em] text-brand-red">Why Choose Us</span>
          <h2 className="mt-4 mb-16 md:mb-24 font-anton uppercase text-5xl md:text-7xl tracking-tight leading-[0.9] max-w-3xl">
            Quality Work.<br /><span className="text-brand-red">Lasting Results.</span>
          </h2>
        </Reveal>

        <div className="divide-y divide-brand-concrete">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 py-10 md:py-14 group">
                <div className="md:col-span-3">
                  <span className="font-anton text-7xl md:text-8xl text-stroke-red leading-none group-hover:[-webkit-text-stroke:2px_#E01B22] transition-all">
                    {c.n}
                  </span>
                </div>
                <h3 className="md:col-span-4 font-anton uppercase text-3xl md:text-4xl tracking-tight leading-none self-center">
                  {c.title}
                </h3>
                <p className="md:col-span-5 font-ibm text-white/60 text-base md:text-lg leading-relaxed self-center">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
